module.exports = __webpack_public_path__ + "img/teto.fab4e3ac.png";